import { render, staticRenderFns } from "./ResultsMini.vue?vue&type=template&id=757496bc&scoped=true&"
import script from "./ResultsMini.vue?vue&type=script&lang=js&"
export * from "./ResultsMini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757496bc",
  null
  
)

export default component.exports